export const RQ_GET_JOINT_VISIT_REPORT_API = {
  url:'dailyvisitjoinee/joint-visit-report/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method: 'GET',
  auth: true,
};
